var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "50", viewBox: "0 0 32 50", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "selection-outline-icon"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M19.56 32.76c.091-1.019.357-2.344.223-3.884C19.239 22.634 16 12.882 16 7.984 16 4.784 17.978 0 17.978 0h12.2S32 5.452 32 7.984c0 5.59-3.083 14.294-3.795 20.528-.183 1.598.032 3.075.257 4.248.384 2.001.577 3.24.577 3.24h-9.992s.31-.97.513-3.24z", id: "b" }),
      React.createElement("path", { d: "M11.56 39.76c.091-1.019.357-2.344.223-3.884C11.239 29.634 8 19.882 8 14.984 8 11.784 9.978 7 9.978 7h12.2S24 12.452 24 14.984c0 5.59-3.083 14.294-3.795 20.528-.183 1.598.032 3.075.257 4.248.384 2.001.577 3.24.577 3.24h-9.992s.31-.97.513-3.24z", id: "a" }),
      React.createElement(
        "mask",
        { id: "c", x: "0", y: "0", width: "16", height: "36", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#a" })
      ),
      React.createElement("path", { d: "M3.56 46.76c.091-1.019.357-2.344.223-3.884C3.239 36.634 0 26.882 0 21.984 0 18.784 1.978 14 1.978 14h12.2S16 19.452 16 21.984c0 5.59-3.083 14.294-3.795 20.528-.183 1.598.032 3.075.257 4.248.384 2.001.577 3.24.577 3.24H3.047s.31-.97.513-3.24z", id: "d" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#b" }),
      React.createElement("path", { stroke: "#222", d: "M18.317.5h11.498l.17.54c.212.683.423 1.405.621 2.133.147.541.28 1.065.397 1.565.319 1.37.497 2.487.497 3.246 0 2.555-.5 5.216-1.917 11.174l-.04.166c-1.149 4.83-1.574 6.848-1.835 9.131-.162 1.422-.052 2.758.263 4.399a122.607 122.607 0 0 1 .48 2.646h-8.766c.063-.304.131-.691.199-1.165.066-.464.125-.974.174-1.53.012-.137.028-.285.05-.473l.064-.525c.148-1.226.191-2.03.109-2.974-.198-2.271-.682-4.788-1.68-9.162l-.184-.801C16.931 12.395 16.5 10.142 16.5 7.984c0-.708.103-1.545.296-2.483.167-.81.395-1.673.67-2.561A37.555 37.555 0 0 1 18.318.5z" }),
      React.createElement("use", { stroke: "#222", mask: "url(#c)", strokeWidth: "2", fill: "#F8F8F8", strokeDasharray: "2", xlinkHref: "#a" }),
      React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#d" }),
      React.createElement("path", { stroke: "#222", d: "M2.317 14.5h11.498l.17.54c.212.683.423 1.405.621 2.133.147.541.28 1.065.397 1.565.319 1.37.497 2.487.497 3.246 0 2.555-.5 5.216-1.917 11.174l-.04.166c-1.149 4.83-1.574 6.848-1.835 9.131-.162 1.422-.052 2.758.263 4.399a122.607 122.607 0 0 1 .48 2.646H3.684c.063-.304.131-.691.199-1.165.066-.464.125-.974.174-1.53.012-.137.028-.285.05-.473l.064-.525c.148-1.226.191-2.03.109-2.974-.198-2.271-.682-4.788-1.68-9.162l-.184-.801C.931 26.395.5 24.142.5 21.984c0-.708.103-1.545.296-2.483.167-.81.395-1.673.67-2.561a37.554 37.554 0 0 1 .851-2.44z" })
    )
  );
});


// WEBPACK FOOTER //
// ../public/images/icons/selection-outline.svg?react-svg